import axios from 'axios';

/**
 * What `responseHandler` (apps/api/src/utils/lambdaResponse.ts) wraps a Lambda failure in.
 *
 * The handler's own payload is nested under `message`, so the app-level code reads at
 * `data.message.code` — NOT `data.code`.
 */
interface LambdaErrorBody {
  statusCode?: number;
  message?: {
    message?: string;
    code?: string;
  };
}

export function getRestErrorCode(error: unknown): string | undefined {
  return axios.isAxiosError<LambdaErrorBody>(error)
    ? error.response?.data?.message?.code
    : undefined;
}

// A coded REST failure's own copy, or the fallback its caller would have shown anyway.
export const resolveRestErrorKey = (
  error: unknown,
  messageKeys: ReadonlyMap<string, string>,
  fallbackKey: string,
): string => {
  const code = getRestErrorCode(error);

  return (
    (code === undefined ? undefined : messageKeys.get(code)) ?? fallbackKey
  );
};
